<template>
    <section class="tekst light purple">
        <circles-layout></circles-layout>
        <h1>Samen in ontwikkeling</h1>
        <p>De pandemie en de steeds veranderende regels legden een enorme druk op iedereen die bij het onderwijs betrokken is. Ondanks de belemmeringen die COVID-19 met zich meebracht is het ons gelukt om het onderwijs door te laten gaan. We weten nu dat wij heel snel kunnen schakelen en flexibel zijn als dat nodig is. De knop ging om: het onderwijs moest immers door! De online onderwijswereld ging afgelopen jaar voor ons in een rap tempo open. Gelukkig waren onze systemen en ICT-infrastructuur al goed ingericht. Hierdoor konden we binnen no time onze studenten en leerlingen online onderwijs bieden.</p>

        <p>Als vitale organisatie binnen de samenleving hebben wij laten zien dat het mogelijk is om ook onder moeilijke omstandigheden, met verenigde kracht, goed onderwijs te verzorgen. Wij hebben een nauwe verbondenheid met bedrijven en instellingen in onze regio. Daardoor zijn wij er tevens in geslaagd om ondanks de beperkingen invulling te geven aan stages en praktijkvorming.</p>

        <p>De crisis kent niet alleen negatieve effecten. Het biedt ons ook nieuwe inzichten en mogelijkheden en daarmee kansen. Zo zijn bijvoorbeeld de versnelde technologisering en digitalisering, en het meer gepersonaliseerd onderwijs positieve effecten die wij borgen en door ontwikkelen in de toekomst.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'OntwikkelingIntro',
        meta: {
            title: 'OntwikkelingIntro',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
